import React, { useEffect, useState } from "react";
import DataOverview from "../components/data/DataOverview";
import { useLocation, useMatch, useParams } from "react-router-dom";
import Loader from "../components/layouts/Loader";

const tableName = "tags";
const textName = "Tags";
const editPathName = "/tags/:id";
const tableColumns = [
  {
    displayName: "Name",
    dataField: "name",
    sort: true,
  },
  {
    displayName: "Slug",
    dataField: "slug",
    sort: true,
  },
  {
    displayName: "Tools",
    dataField: "tools",
    sort: false,
  },
];
const fieldData = [
  {
    displayName: "Name",
    placeholder: "Name",
    fieldName: "name",
    fieldType: "text",
    colSize: 3,
    required: true,
    requiredMessage: "Field is required",
  },
  {
    displayName: "Slug",
    placeholder: "Slug",
    fieldName: "slug",
    fieldType: "text",
    colSize: 3,
    required: true,
    requiredMessage: "Field is required",
  },
  {
    displayName: "Icon",
    placeholder: "Icon",
    fieldName: "icon",
    fieldType: "text",
    colSize: 3,
    required: false,
  },
];
const fieldDataDefault = {
  name: "",
  icon: "",
  slug: "",
};

const Tags = () => {
  const { id } = useParams();
  const location = useLocation();
  const match = useMatch(editPathName);
  const [loading, setLoading] = useState(true);
  let parentRoute = location.pathname;
  useEffect(() => {
    setLoading(false);
  }, []);

  if (match) {
    parentRoute = match.pattern.path.replace("/:id", "");
  }

  if (loading) return <Loader />;
  return (
    <DataOverview
      id={id ?? ""}
      tableName={tableName}
      pageMode={id ? "edit" : "list"}
      route={location.pathname}
      parentRoute={parentRoute}
      pageTitle={textName}
      listTitle={textName}
      listSubTitle={""}
      addTitle={"Add "}
      addSubTitle={""}
      editTitle={`Edit ${textName}`}
      editSubTitle={""}
      tableColumns={tableColumns}
      fieldData={fieldData}
      fieldDataDefault={fieldDataDefault}
    />
  );
};

export default Tags;
